module.exports = __webpack_public_path__ + "media/images/yellow_circle_small-a9fa64543b9248a24305173fbc3c7025.svg";